export default __webpack_public_path__ + "static/media/2_Open Letter Legalisierung_Jetzt.a83ec5d9.pdf";